import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import {
  FormTemplateFieldTypes,
  getFormFieldDefaultSubtext,
} from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import { ModalFieldWrapper, ModalTextField } from '../../styled';

type EditSubtextFieldProps = {
  prefix?: string;
  isEditMode: boolean;
};

export function EditSubtextField({
  prefix,
  isEditMode,
}: EditSubtextFieldProps) {
  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>(getFieldNameWithPrefix('type', prefix));

  return (
    <ModalFieldWrapper>
      <ModalTextField
        label="Subtext"
        name={getFieldNameWithPrefix('nameSubtext', prefix)}
        initialValue={
          isEditMode ? undefined : getFormFieldDefaultSubtext(fieldType)
        }
        tooltipText="Optional. The subtext will be displayed under the field name."
      />
    </ModalFieldWrapper>
  );
}
